import React, { useEffect, useState } from 'react';

import Images from "../../components/Images/Images";
import amazon from '../../../static/assets/images/marketplace/amazon.svg';
import mercadoLibre from '../../../static/assets/images/marketplace/mercado_libre.svg';

export const MarketPlaceItems = ({ items }) => {
  const itemsLength = items.length;
  const [count, setCount] = useState(1);
  const [isViewMore, setIsViewMore] = useState(false);
  const [isHidden, setIsHidden] = useState(true);
  const [array, setArray] = useState([]);

  function windowSize() {
    if (window.innerWidth < 1024) {
      setIsViewMore(true)
    } else {
      setIsViewMore(false)
    }
  }

  useEffect(() => {
    window.addEventListener("resize", windowSize);
    windowSize();

    return () => {
      window.removeEventListener("resize", windowSize);
    };
  }, [])

  useEffect(() => {
    if (isViewMore) {
      setArray(items.slice(0, 2 * count))

      if (count * 2 >= itemsLength) {
        setIsHidden(false)
      }
    } else {
      setArray(items)
    }
  }, [isViewMore, count])

  return (
    <div className="mp-block mp-items">
      <div className="mp-items__content">
        <div className="mp-items__items">
          {array.map((item, index) => {
            return (<div key={`items-marketplace-${index}`} className="mp-item">
              <div className="mp-item__image">
                <Images src={item.product_image.url} alt="product" />
              </div>
              <div className="mp-item__line" />
              <div className="mp-item__title" dangerouslySetInnerHTML={{ __html: item.product_name.html }} />
              <div className="mp-item__marketplace">
                <a className={`mp-item__link ${item.amazon_url.url ? "" : "mp-item__disabled"}`} href={item.amazon_url.url} target="_blank" rel="noopener noreferrer">
                  <Images src={amazon} alt="amazon"/>
                </a>
                <div className="mp-item__separator" />
                <a className={`mp-item__link ${item.mercado_libre_url.url ? "" : "mp-item__disabled"}`} href={item.mercado_libre_url.url} target="_blank" rel="noopener noreferrer">
                  <Images src={mercadoLibre} alt="mercado libre"/>
                </a>
              </div>
            </div>)
          })}
        </div>
      </div>
      {
        isViewMore && isHidden && itemsLength > 2 && (
          <div className="mp-items__view-more">
            <button onClick={() => setCount(count + 1)}>Ver Más</button>
          </div>
        )
      }
    </div>
  )
};
